var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4",attrs:{"id":"dashboard"}},[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex justify-space-between mb-5"},[_c('h2',[_vm._v("Dashboard")])])]),_c('upload-video-modal',{attrs:{"open-dialog":_vm.dialog},on:{"closeDialog":function($event){_vm.dialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }